import React, { Component, Fragment } from 'react';
import axios from 'axios';
import Axios from 'axios';
import moment from 'moment';
import { notification, AutoComplete, Select, Modal, Button, Radio, Form, Input, Checkbox, Tooltip, Table, DatePicker } from 'antd';
import { MEDICINES_GETALL, MEDICINES_GETALL_CURRENT_MEDICINES, CURRENT_MEDICINES_STOP, SEARCH_DRUGS, DRUGS_CONSTANT, DRUG, LATEST_DATA_FOR_EACH_VITAL, CIMS_INFO, CIMS_INTERACTION_EXISTS, CIMS_INTERACTION, PRESCRIPTION_DATA, DELETE_MEDICINE, MYHC_APPTYPE, WOODLANDS, HOSPITALDEFAULTS, LOADER_BLACK, AVERAGE_BSA_FOR_MALE, AVERAGE_BSA_FOR_FEMALE, ADD_DRUGS, LOADER_RED, PRESCRIPTION_STORE, DOCTOR_AGENT_LIST, DISCHARGE_MEDICINE_LIST_API, UOM_MASTER_LIST } from '../../utils/constant';
import LS_SERVICE from '../../utils/localStorage';
import qs from 'qs';
import {
    LAST_VITAL_ADDED_DATA,
    BMI_CALCULATE,
    LOADER,
    BSA_CALCULATE,
    PATIENT_INFO,
    USERTYPES,
    MARK_DEFAULT_CORRECTION_DOSE,
    SAVE_TARGET_BLOOD_SUGAR,
    FETCH_DEFAULT_CORRECTION_DOSE

} from '../../utils/constant';
import DischargeIcon from "../../assets/images/discharge.png"
const { Option } = Select;


class CurrentMedsPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeMediListModal: false,
            current_medicine_load: false,
            current_medicine_list: [],
            patient: {
                hospital_id   : LS_SERVICE.get("FACILITY_ID") != undefined ? LS_SERVICE.get("FACILITY_ID") : 0,
                patient_id    : LS_SERVICE.get("call_patient_id") != undefined ? LS_SERVICE.get("call_patient_id") : 0,
                qms_token_id  : LS_SERVICE.get("call_patient_qms_token_id") != undefined ? LS_SERVICE.get("call_patient_qms_token_id") : 0,
            },
            constantCurrentMeds: [],
            drugDailyFrequencyMeds: {},
            showAddDrugButton: true,
            formIsFetchingDrug: false,
            selectDrugValue: '',
            searchDrugs: [],
            drug_id: '',
            drug_name: '',
            selectDrugName: '',
            addedDrugsLists: [],
            cimsallow: typeof LS_SERVICE.get('cimsEnabled') != 'undefined' && LS_SERVICE.get('cimsEnabled') === 'Y' ? true : false,
            dischargeMedicineList: [],
            isMedicineShow: false,
            DRUGSConstants: this.props.constants ?? [],
            UomListData: [],
            drug_route: null,
            drug_urgency: '',
            daily_frequency: null,
            drug_dosage: '',
            drug_dosage_form_text: null,
            drug_instruction: '',
            drug_schedules: [],
            drug_number_of_days: null,
            drug_duration_time: "Days",
            drug_start_date: null,
            drug_end_date: null
        }
        this.onDrugssearch = this.onDrugssearch.bind(this);
        this.currentMedicinesListRef = React.createRef();
    }

    async componentDidMount() {
        await this.getDischargeMedicineList();
        this.UomListLoad();
    }

    UomListLoad = () => {
        let params = {
          active: 1
        }
        axios.post(UOM_MASTER_LIST, qs.stringify(params)).then(success => {
          console.log(success.data);
          this.setState({ UomListData: success.data.data });
        }).catch(err => console.log(err))
    }

    async handleActiveMedsList() {
        var medicineData = [];
        var Mobject = {};
        var addedDrugsLists = [];
        this.setState({
            activeMediListModal: true,
            current_medicine_load: { indicator: LOADER_RED },
        });
        let { patient } = this.state;
        if (patient == null || typeof patient == 'undefined') {
            patient = this.props.patient;
        }
        const { qms_token_id, patient_id } = patient;
        await axios.get(MEDICINES_GETALL_CURRENT_MEDICINES({ patient_id, reference_type: 0, reference_id: qms_token_id })).then(success => {
            let currentMedsList = success.data.data.details.current_medicines;
            let constants = success.data.data.constants
            this.setState({
                constantCurrentMeds: constants,
            })
            this.optionDailyFrequencyLoad();
            currentMedsList.map(med => {
                let drugFreqText = med.drug_frequency ? Object.keys(constants.drugFrequency).find(key => constants.drugFrequency[key].id === med.drug_frequency) : null;
                drugFreqText = drugFreqText != null ? constants.drugFrequency[drugFreqText].description : '';
                if (med.dose_for_schedule == 'Y' && med?.schedules?.length > 1) {
                    for (var sch of med?.schedules) {
                        let medicine_drug_frequency = "-";
                        if(med.drug_frequency != null)
                        {
                            let med_frequency_data = constants.dailyFrequency.filter((v, i) => v.id == med.drug_frequency);
                            if(med_frequency_data.length > 0)
                            {
                                medicine_drug_frequency = med_frequency_data[0].description;
                            }
                        }
                        Mobject = {
                            drug_id: med.drug_id,
                            active: med.active,
                            drug_name: med.drug_name == null ? '-' : med.drug_name,
                            route: med.route == null ? '-' : constants.route.filter(r => { if (med.route == r.id) return r.description })[0].description,
                            priority: med.urgency == null ? '-' : constants.drugUrgency.filter(r => { if (med.urgency == r.id) return r.description })[0].description,
                            frequency: medicine_drug_frequency,
                            schedule: sch == null ? '-' : sch == 1 ? 'Morning' : sch == 2 ? 'Afternoon' : sch == 3 ? 'Evening' : sch == 4 ? 'Evening' : '-',
                            instruction: sch == null ? '-' : sch == 1 ? constants.drugMorningInstructions.filter(r => { if (med.instruction_morning == r.id) return r.description })[0].description : sch == 2 ? constants.drugAfternoonInstructions.filter(r => { if (med.instruction_afternoon == r.id) return r.description })[0].description : sch == 3 ? constants.drugEveningInstructions.filter(r => { if (med.instruction_evening == r.id) return r.description })[0].description : sch == 4 ? constants.drugNightInstructions.filter(r => { if (med.instruction_night == r.id) return r.description })[0].description : '-',
                            dosage: sch != null ? sch == 1 ? med.dosage_value_morning + ' ' + med.dosage_form_text : sch == 2 ? med.dosage_value_afternoon + ' ' + med.dosage_form_text : sch == 3 ? med.dosage_value_evening + ' ' + med.dosage_form_text : sch == 4 ? med.dosage_value_night + ' ' + med.dosage_form_text : null : '-',
                            //  duration: med.number_of_days == null ? '-' : med.number_of_days + " " + med.drug_duration_time,
                            duration: med.number_of_days ? med.number_of_days + " " + med?.number_of_days_type : (parseInt(med?.drug_frequency) != 3 ? (parseInt(med?.daily_frequency) == 4 ? '-' : med.isOnlyCurrentMeds == 'Y' ? '-' : 'Till review') : '-'),
                            start_date: med.start_date == null ? '-' : moment(med.start_date).format('D MMM, YYYY'),
                            end_date: med.end_date == null ? '-' : moment(med.end_date).format('D MMM, YYYY'),
                            action: <span><div className='mr-4'><button type="button" className="btn btn-outline-primary px-3  small text-uppercase" disabled={med.prescriptionDrugActive == 'N' ? 'disabled' : null} onClick={() => this.stopDrug(med.prescriptionDrugId)}>{(med.prescriptionDrugActive == 'Y') ? 'STOP' : 'STOPPED'}</button></div>{(med.prescriptionDrugActive == 'N') ? <><div className="pt-2">{med.prescriptionDrugActive == 'Y' ? '' : <span className='font-weight-bold'>Stopped By : <span className='font-weight-light'>{med.doctor_name} </span></span>}</div><div>{!med.updated_at == null ? '' : <span className='font-weight-bold'>Stopped At : <span className='font-weight-light'>{moment(med.updated_at).format('D MMM, YYYY')}</span></span>}</div></> : ''}
                            </span>,
                            doseforscduled: 'Y',
                            scduled: med?.schedules ? med.schedules.length : 0,
                            isDischargeMedicine: false, // Flag to differentiate
                        }
                        medicineData.push(Mobject);
                    }
                } else {
                    let medicine_drug_frequency = "-";
                    if(med.drug_frequency != null)
                    {
                        let med_frequency_data = constants.dailyFrequency.filter((v, i) => v.id == med.drug_frequency);
                        if(med_frequency_data.length > 0)
                        {
                            medicine_drug_frequency = med_frequency_data[0].description;
                        }
                    }
                    Mobject = {
                        drug_id: med.drug_id,
                        active: med.active,
                        drug_name: med.drug_name == null ? '-' : med.drug_name,
                        route: med.route == null ? '-' : constants.route.filter(r => { if (med.route == r.id) return r.description })[0].description,
                        priority: med.urgency == null ? '-' : constants.drugUrgency.filter(r => { if (med.urgency == r.id) return r.description })[0]?.description,
                        // frequency: med.drug_frequency == null ? '-' : med.drug_frequency == 2 ? med.days_in_week_text : (med.drug_frequency == 1 ? this.state.drugDailyFrequencyMeds[med.daily_frequency] ? this.state.drugDailyFrequencyMeds[med.daily_frequency] : '-' : drugFreqText),
                        frequency: medicine_drug_frequency,
                        schedule: med.schedule_name == null ? '-' : med.schedule_name,
                        dosage: med.dosage_value != null ? med.dosage_value + " " + med.dosage_form_text : '-',
                        instruction: med.instruction == null ? '-' : constants.drugInstructions.filter(r => { if (med.instruction == r.id) return r.description })[0].description,
                        // duration: med.number_of_days ? med.number_of_days + " " + med?.number_of_days_type : (parseInt(med.drug_frequency) != 3 ? (parseInt(med?.daily_frequency) == 4 ? '-' : med.daily_frequency != null ? 'Till review' : '-') : '-'),
                        duration: med.number_of_days ? med.number_of_days + " " + med?.number_of_days_type : (parseInt(med?.drug_frequency) != 3 ? (parseInt(med?.daily_frequency) == 4 ? '-' : med.isOnlyCurrentMeds == 'Y' ? '-' : 'Till review') : '-'),
                        start_date: med.start_date == null ? '-' : moment(med.start_date).format('D MMM, YYYY'),
                        end_date: med.end_date == null ? '-' : moment(med.end_date).format('D MMM, YYYY'),
                        action: <span><div className='mr-4'><button type="button" className="btn btn-outline-primary px-3  small text-uppercase" disabled={med.prescriptionDrugActive == 'N' ? 'disabled' : null} onClick={() => this.stopDrug(med.prescriptionDrugId)}>{(med.prescriptionDrugActive == 'Y') ? 'STOP' : 'STOPPED'}</button></div>{(med.prescriptionDrugActive == 'N') ? <><div className="pt-2">{med.prescriptionDrugActive == 'Y' ? '' : <span className='font-weight-bold'>Stopped By : <span className='font-weight-light'>{med.doctor_name} </span></span>}</div><div>{!med.updated_at == null ? '' : <span className='font-weight-bold'>Stopped At : <span className='font-weight-light'>{moment(med.updated_at).format('D MMM, YYYY')}</span></span>}</div></> : ''}
                        </span>,
                        doseforscduled: 'N',
                        scduled: 0,
                        isDischargeMedicine: false, // Flag to differentiate
                    }
                    medicineData.push(Mobject);
                }
            });

            const dischargeMedicineData = this.transformDischargeMedicineList(this.state.dischargeMedicineList || [], constants)
            medicineData.push(...dischargeMedicineData)

            medicineData.map((v, k) => {
                if (v.active == 'Y')
                    addedDrugsLists.push(v.drug_id)
            });
            this.setState({
                current_medicine_list: medicineData,
                current_medicine_load: false,
            });
        }).catch(err => {
            console.log(err);
        });
        const PARAMS = {
            patient_id,
            reference_type: LS_SERVICE.get('reference_type'),
            reference_id: qms_token_id,
            hospital_id: LS_SERVICE.get('slot_hospital_master') == 'Y' ? LS_SERVICE.get('slot_hospital_id') : null
        }
        PARAMS.store_id = LS_SERVICE.get("STORE_ID");
        PARAMS.facility_id = LS_SERVICE.get("FACILITY_ID");
        PARAMS.enterprise_id = LS_SERVICE.get("ENTERPRISE_ID");
        Axios.get(PRESCRIPTION_DATA(PARAMS))
            .then(success => {
                let { data } = success.data,
                    drugId = data.details.map((v, k) => {
                        if (v.prescriptionDrugActive == 'Y')
                            addedDrugsLists.push(v.drug_id)
                    });
            }).catch(err => console.log(err.response));

        this.setState({
            addedDrugsLists: addedDrugsLists
        })
    }

    handleCancel = () => {
        this.setState({
            drug_id: '',
            drug_name: '',
            selectDrugValue: '',
            current_medicine_list: [],
            searchDrugs: [],
            activeMediListModal: false,
            current_medicine_load: false,
            showAddDrugButton: true,
        });
    };

    optionDailyFrequencyLoad() {
        return this.state.constantCurrentMeds.dailyFrequency.map((obj, i) => {
            this.state.drugDailyFrequencyMeds[obj.id] = obj.description;
        }, this)
    }

    getRowSpans = (arr, key) => {
        let sameValueLength = 0;
        const RowSpans = [];
        for (let i = arr.length - 1; i >= 0; i--) {
            if (i === 0) {
                RowSpans[i] = sameValueLength + 1;
                continue;
            }

            if (arr[i][key] === arr[i - 1][key] && arr[i]['active'] == arr[i - 1]['active'] && arr[i]['active'] == 'Y' && (arr[i]['doseforscduled'] == 'Y' && arr[i - 1]['doseforscduled'] == 'N' || arr[i]['doseforscduled'] == 'N')) {
                RowSpans[i] = 0;
                sameValueLength++;
            }
            else if (arr[i]['active'] == arr[i - 1]['active'] && arr[i - 1]['active'] == 'N' && (arr[i]['drug_id'] == arr[i - 1]['drug_id']) && (arr[i]['doseforscduled'] == arr[i - 1]['doseforscduled'] && arr[i - 1]['doseforscduled'] == 'N')) {
                RowSpans[i] = sameValueLength + 1;
                sameValueLength = 0;
            }
            else if (arr[i][key] === arr[i - 1][key] && arr[i]['active'] == arr[i - 1]['active'] && arr[i - 1]['active'] == 'N' && (arr[i]['drug_id'] == arr[i - 1]['drug_id']) && (arr[i]['doseforscduled'] == arr[i - 1]['doseforscduled']) && ((arr[i]['scduled'] != 0 && sameValueLength < arr[i]['scduled'] - 1) || arr[i]['scduled'] == 0)) {
                RowSpans[i] = 0;
                sameValueLength++;
            }
            else if (arr[i][key] === arr[i - 1][key] && arr[i]['active'] == arr[i - 1]['active'] && arr[i - 1]['active'] == 'Y' && (arr[i]['drug_id'] == arr[i - 1]['drug_id']) && (arr[i]['doseforscduled'] == arr[i - 1]['doseforscduled']) && ((arr[i]['scduled'] != 0 && sameValueLength <= arr[i]['scduled'] - 1) || arr[i]['scduled'] == 0)) {
                RowSpans[i] = 0;
                sameValueLength++;
            }
            else {

                RowSpans[i] = sameValueLength + 1;
                sameValueLength = 0;
            }

        }
        return RowSpans;
    };

    getRowSpansForSchduled = (arr) => {
        let sameValueLength = 0;
        const RowSpans = [];
        for (let i = arr.length - 1; i >= 0; i--) {

            if (i === 0) {
                RowSpans[i] = sameValueLength + 1;
                continue;
            }
            if ((arr[i]['active'] == arr[i - 1]['active']) && (arr[i]['drug_id'] == arr[i - 1]['drug_id']) && (arr[i]['doseforscduled'] == arr[i - 1]['doseforscduled'] && arr[i - 1]['doseforscduled'] == 'Y') && (arr[i]['scduled'] != 0 && sameValueLength < arr[i]['scduled'] - 1)) {
                RowSpans[i] = 0;
                sameValueLength++;
            } else {
                RowSpans[i] = sameValueLength + 1;
                sameValueLength = 0;
            }
        }
        return RowSpans;
    }



    stopDrug = async (stopPrescriptionDrugId) => {
        let doctor_id = LS_SERVICE.get('staff_id');
        let stopDrugIds = []
        stopDrugIds.push(stopPrescriptionDrugId);
        let params = {
            stopDrugIds: stopDrugIds,
        }
        axios.put(CURRENT_MEDICINES_STOP({ stopPrescriptionDrugId, doctor_id }), params).then(res => {
            notification.success({
                message: 'Drug stopped successfully',
                placement: 'topRight'
            });
            this.handleActiveMedsList();
        }).catch(
            err => {
                notification.error({
                    message: 'failed to stop medicine',
                    placement: 'topRight'
                });
                console.log(err);
            }
        );
    }

    onChangeDrugsSelect = async (value, props) => {
        await this.setState({
            drug_id: props.drug_id,
            selectDrugValue: value,
            drug_name: value,
        });
    }

    onDrugssearch(search) {
        this.setState({
            formIsFetchingDrug: true,
            selectDrugValue: search,
        })
        let params = { search: search };
        if (LS_SERVICE.get("user_type") == USERTYPES.admin) {
            params.hospital_id = LS_SERVICE.get('slot_hospital_master') == 'Y' ? LS_SERVICE.get('admin_hospital_id') : null;
        } else if (LS_SERVICE.get("user_type") == USERTYPES.superadmin) {
            params.hospital_id = LS_SERVICE.get('master_hospital_id') ?? null;
        } else {
            params.hospital_id = LS_SERVICE.get('slot_hospital_master') == 'Y' ? LS_SERVICE.get('slot_hospital_id') : null;
        }
        params.store_id = LS_SERVICE.get("STORE_ID");
        params.facility_id = LS_SERVICE.get("FACILITY_ID");
        params.enterprise_id = LS_SERVICE.get("ENTERPRISE_ID");
        if(!search || search == null || search == ''){
          this.setState({
            searchDrugs: LS_SERVICE.get("favouriteMedicines") || [],
            formIsFetchingDrug: false,
            showAddDrugButton: true
          });
        }
        else{
          Axios.post(SEARCH_DRUGS, qs.stringify(params)).then(success => {
              this.setState({
                  searchDrugs: success.data.medicine_list,
                  formIsFetchingDrug: false,
                  showAddDrugButton: (search.length > 2 && success.data?.medicine_list?.length == 0) ? false : true,
              })
          }).catch(err => console.log(err));
        }
    }

    saveMedicineData = async () => {
        let { patient } = this.state;
        if (patient == null || typeof patient == 'undefined') {
            patient = this.props.patient;
        }
        const { qms_token_id, patient_id } = patient;
        let medicineType = 'F';
        if (this.state.drug_id == '' || this.state.drug_id == null) {
            let emailParams = {
                drug_name: this.state.drug_name,
            }
            await Axios.post(ADD_DRUGS, {
                hospital_id: LS_SERVICE.get('slot_hospital_id'),
                hospital_master: LS_SERVICE.get('slot_hospital_master'),
                name: this.state.drug_name,
                isCurrentMeds: true,
                emailParams: emailParams
            })
                .then(success => {
                    this.setState({
                        drug_id: success.data.data.id,
                    });
                    medicineType= 'N'
                }).catch(err => {
                    console.log(err);
                })
        }
        const medicine_data = {
            drug_id: this.state.drug_id,
            drug_name: this.state.drug_name,
            prescription_drug_id: -1,
            active: 'Y',
            isOnlyCurrentMeds: 'Y',
            medicine_type:medicineType,
            route: this.state.drug_route,
            urgency: this.state.drug_urgency,
            drug_frequency: this.state.daily_frequency,
            schedules: this.state.drug_schedules,
            dosage: this.state.drug_dosage,
            dosage_value: this.state.drug_dosage,
            dosage_form_text: this.state.drug_dosage_form_text,
            instruction: this.state.drug_instruction,
            number_of_days: this.state.drug_number_of_days,
            number_of_days_type: this.state.drug_duration_time,
            start_date: this.state.drug_start_date ? moment(this.state.drug_start_date).format('YYYY-MM-DD') : null,
            end_date: this.state.drug_end_date ? moment(this.state.drug_end_date).format('YYYY-MM-DD') : null
        }
        const PRESCRIPTION_PARAMS = {
            reference_type: LS_SERVICE.get('reference_type'),
            reference_id: qms_token_id,
            patient_id,
            medicine_data: [medicine_data],
        };
        await Axios.post(PRESCRIPTION_STORE, qs.stringify(PRESCRIPTION_PARAMS))
            .then(success => {
                this.handleActiveMedsList();
                this.formClear();
                this.setState({
                    isMedicineShow: false
                })
            }).catch(err => console.log(err));
    }

    addMedicine = async () => {
        this.setState({
            isMedicineShow: true,
            searchDrugs: [],
            drug_id: '',
            drug_name: '',
            selectDrugValue: '',
            drug_route: null,
            drug_urgency: '',
            daily_frequency: null,
            drug_dosage: '',
            drug_dosage_form_text: null,
            drug_instruction: '',
            drug_schedules: [],
            drug_number_of_days: null,
            drug_duration_time: "Days",
            drug_start_date: null,
            drug_end_date: null
     }, () => {
        setTimeout(() => {
            this.currentMedicinesListRef?.current?.focus();         
            }, 0);
        });
    };

    formClear() {
        this.setState({
            searchDrugs: [],
            drug_id: '',
            drug_name: '',
            selectDrugValue: '',
            drug_route: null,
            drug_urgency: '',
            daily_frequency: null,
            drug_dosage: '',
            drug_dosage_form_text: null,
            drug_instruction: '',
            drug_schedules: [],
            drug_number_of_days: null,
            drug_duration_time: "Days",
            drug_start_date: null,
            drug_end_date: null
        })
    }

    handleAddDrug() {
        this.setState({
            showAddDrugButton: true,
            drug_id: null,
            drug_name: this.state.selectDrugValue,
        });
    }

    optionDrugLoad() {
        if (this.state.searchDrugs !== undefined && this.state.searchDrugs.length > 0) {
            return this.state.searchDrugs.map((obj, i) => {
                return (<Option key={i} value={obj.name} drug_id={obj.id} fav={obj.fav} disabled={(this.state.addedDrugsLists && this.state.addedDrugsLists.includes(obj.id))} title={obj.name}>
                    <span className="desc">
                        {obj.name}
                    </span>
                    {/* <span className="float-right text-primary">
                {(LS_SERVICE.get("user_type") == USERTYPES.doctor) ?
                  <i className={`icon_unique icon_star align-star ${obj.fav ? "favourite" : ""}`}></i>
                  : null}
                {this.state.cimsallow ? (
                  <Button onClick={(e) => { e.stopPropagation(); this.showModalInfo() }} className="nostyle-link p-0">
                    <i className='icon_info'></i>
                  </Button>
                ) : null}
              </span> */}
                </Option>
                )
            })
        } else return null
    }

    async getDischargeMedicineList() {
        const PARAMS = {
          facilityId: LS_SERVICE.get("FACILITY_ID"),
          patientId: LS_SERVICE.get("call_patient_id"),
          service_type: "both",
          status: 0,
        };
        try {
          const response = await Axios.post(DISCHARGE_MEDICINE_LIST_API, PARAMS);
          if (response && response?.status === 200) {
            const data = response?.data?.data;  
            // Current date time
            const now = new Date();
            // Filter records
            const filtered = data.filter(item => {
              return (
                item.discharge_medicine === true &&
                new Date(item.endmedicationdatetime) > now
              );
            });
    
            this.setState({
              dischargeMedicineList: filtered
            })
      
          }
        } catch (error) {
          console.error("Error fetching discharge medicine list:", error);
        }
    }

    transformDischargeMedicineList(dischargeMeds, constant) {
        const dailyFrequency =this.props.constants?.dailyFrequency;
        const medicineData = [];
    
        dischargeMeds.forEach(med => {
            const frequencyObjKey = dailyFrequency
                ? dailyFrequency.find(f => f.id == med.daily_frequency)
                : null;
    
            // Determine duration unit
            let displayDurationForm = "";
            if (med.frequency_id === 2) {
                displayDurationForm = "Weeks";
            } else if (frequencyObjKey?.nature) {
                const { nature, interval_per: interval } = frequencyObjKey;
    
                if (
                    nature === "Once" ||
                    (nature === "Frequency" && ["Days", "Alternate Day"].includes(interval))
                ) {
                    displayDurationForm = "Days";
                } else if (nature === "Frequency" && interval === "Weeks") {
                    displayDurationForm = "Weeks";
                } else if (nature === "Frequency" && interval === "Months") {
                    displayDurationForm = "Months";
                }
            }
    
            const Mobject = {
                drug_name: (
                    <span className="discharge-medicine">
                        {med.service_name || "-"}
                        {med.discharge_medicine == true && (
                            <span className='ml-2'><img src={DischargeIcon} alt="discharge" class="existing-med-icon" style={{width: "18px"}} /></span>
                        )}
                    </span>
                ), // Visual distinction
                route: med?.route || "-",
                priority: med?.priority || "-",
                frequency: med?.frequency || "-",
                schedule: med?.schedule_name?.replace(/-/g, ", ") || "-",
                dosage:
                    med?.dosage != null
                        ? med?.dosage_form_text != null
                            ? `${med?.dosage} ${med?.dosage_form_text}`
                            : med?.dosage
                        : "-",
                instruction: med?.orderInstructions || "-",
                duration: med?.number_of_days
                    ? `${med.number_of_days} ${displayDurationForm}`
                    : "-",
                start_date: med?.startmedicationdatetime
                    ? moment(med.startmedicationdatetime).format("D MMM, YYYY")
                    : "-",
                end_date: med?.endmedicationdatetime
                    ? moment(med.endmedicationdatetime).format("D MMM, YYYY")
                    : "-"
            };
    
            medicineData.push(Mobject);
        });
    
        return medicineData;
    }

    optionRouteLoad = () => {
        if (this.state.DRUGSConstants !== undefined && this.state.DRUGSConstants?.route?.length > 0) {
            return this.state.DRUGSConstants?.route.map((obj, i) => {
                return (<Option key={i} value={obj.id} title={obj.description}>{obj.description}</Option>)
            })
        }
        else {
            return null
        }
      
    }

    optionPriorityLoad() {
        if (!this.state.DRUGSConstants.drugUrgency || this.state.DRUGSConstants.drugUrgency.length === 0) {
          return (<Option value={0}><span>No Result Found</span></Option>)
        }
        return this.state.DRUGSConstants.drugUrgency.map((obj, i) => {
          return (<Option key={i} value={obj.id} title={obj.description}>{obj.description}</Option>)
        }, this)
    }

    optiondaily_frequencyLoad() {
        if (!this.state.DRUGSConstants.dailyFrequency || this.state.DRUGSConstants.dailyFrequency.length === 0) {
            return (<Option value={0}><span>No Result Found</span></Option>)
          }
          return this.state.DRUGSConstants.dailyFrequency.map((obj, i) => {
            return (<Option key={i} value={obj.id} dataSchedule={obj?.schedule} dataid={obj} title={obj.description}>{obj.description}</Option>)
          }, this)
    }

    optionschedulesLoad() {
        if (!this.state.DRUGSConstants.drugSchedules || this.state.DRUGSConstants.drugSchedules.length === 0) {
            return (<Option value={0}><span>No Result Found</span></Option>)
          }
          return this.state.DRUGSConstants.drugSchedules.map((obj, i) => {
            return (<Option key={i} value={obj.id} title={obj.description}>{obj.description}</Option>)
          }, this)
    }

    optionUomDrugLoad() {
        if (!this.state.UomListData || this.state.UomListData.length === 0) {
          return (<Option value={0}><span>No Result Found</span></Option>)
        }
        return this.state.UomListData.map((obj, i) => {
          return (<Option key={i} value={obj.description} title={obj.description}>{obj.description}</Option>
          )
        }, this)
    }

    optionInstructionLoad() {
        if (!this.state.DRUGSConstants.drugInstructions || this.state.DRUGSConstants.drugInstructions.length === 0) {
            return (<Option value={0}><span>No Result Found</span></Option>)
        }
        return this.state.DRUGSConstants.drugInstructions.map((obj, i) => {
            return (<Option key={i} value={obj.id} title={obj.description}>{obj.description}</Option>)
        }, this)
    }

    optionDurationTypeLoad() {
        // let {disableDurationType} = this.state;
        return (
            <>
                <Option key={1} value="Days" title="Days">Days</Option>
                <Option key={2} value="Weeks" title="Weeks">Weeks</Option>
                <Option key={3} value="Months" title="Months">Months</Option>
                <Option key={4} value="Years" title="Years">Years</Option>
            </>
        )
    }

    onChangeDrugRoute = (val) => {
        this.setState({ drug_route: val }, () => {
            console.log("Updated drug_route:", this.state.drug_route);
        });
    }

    onChangeDrugUrgency = (val) => {
        this.setState({ drug_urgency: val });
    }

    onSelectDailyFrequencyChange = (val) => {
        this.setState({
            daily_frequency: val
        })
    }

    onBlurDrugDosage = (event) => {
        var val = event.target.value;
        //var drugDosageValue = this.getDosageUpdate(event)
        if (val === "" || /^[0-9]*(\.[0-9]{0,2})?$/.test(val)) {
            this.setState({ drug_dosage: val }, () => {
                // this.updateQuantity();
            });
        }
    }

    handleSelectOnUomChange = (val) => {
        this.setState({ drug_dosage_form_text: val });
    }

    onChangeDrugInstruction = (val) => {
        this.setState({ drug_instruction: val });
    }

    selectSchedulesChange = (val) => {
        this.setState({
            drug_schedules: val
        })

    }

    onChangeNumberOfDays = (val) => {
        if (/^0/.test(val.target.value)) {
            this.setState({ drug_number_of_days: '' })
        } else {
            this.setState({
                drug_number_of_days: !isNaN(val.target.value) ? val.target.value : null
            });
        }
    }

    onChangeDurationType = (val) => {
        this.setState({ drug_duration_time: val });
    }
    
    updateStartDate = async (val) => {
        if (val) {
            await this.setState({
                drug_start_date: val
            });
        } else {
            await this.setState({
                drug_start_date: moment()
            });
        }
    }

    updateEndDate = async (val) => {
        if (val) {
            await this.setState({
                drug_end_date: val
            });
        } else {
            await this.setState({
                drug_end_date: moment()
            });
        }
    }
      
    render() {
        const rowSpans = this.getRowSpans(this.state.current_medicine_list, 'drug_name')
        const getRowSpansForSchduled = this.getRowSpansForSchduled(this.state.current_medicine_list)

        const columns = [
            {
                title: 'MEDICINE NAME',
                dataIndex: 'drug_name',
                width: '11%',
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    obj.props.rowSpan = rowSpans[index];
                    return obj;
                }

            },
            {
                title: 'ROUTE',
                dataIndex: 'route',
                width: '9%',
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    obj.props.rowSpan = getRowSpansForSchduled[index];
                    return obj;
                }
            },
            {
                title: 'PRIORITY',
                dataIndex: 'priority',
                width: '7%',
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    obj.props.rowSpan = getRowSpansForSchduled[index];
                    return obj;
                }

            },
            {
                title: 'FREQUENCY',
                dataIndex: 'frequency',
                width: '9%',
                render: (value, row, index) => {
                    const obj = {
                        children: value == "PRN" ? "PRN/SOS" : value,
                        props: {},
                    };
                    obj.props.rowSpan = getRowSpansForSchduled[index];
                    return obj;
                }
            },
            {
                title: 'SCHEDULE',
                dataIndex: 'schedule',
                width: '8%',
            },
            {
                title: 'DOSAGE',
                dataIndex: 'dosage',
                width: '7%',
            },
            {
                title: 'INSTRUCTION',
                dataIndex: 'instruction',
                width: '9%',
            },
            {
                title: 'DURATION',
                dataIndex: 'duration',
                width: '8%',
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    obj.props.rowSpan = getRowSpansForSchduled[index];
                    return obj;
                }
            },
            {
                title: 'START DATE',
                dataIndex: 'start_date',
                width: '9%',
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    obj.props.rowSpan = getRowSpansForSchduled[index];
                    return obj;
                }
            },
            {
                title: 'END DATE',
                dataIndex: 'end_date',
                width: '8%',
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    obj.props.rowSpan = getRowSpansForSchduled[index];
                    return obj;
                }
            },
            {
                title: 'ACTION',
                dataIndex: 'action',
                width: '15%',
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    obj.props.rowSpan = getRowSpansForSchduled[index];
                    return obj;
                }
            },

        ];
        return (
            <Fragment>

                {
                    this.props.pageName == 'today-visit' ?

                        <div data-toggle="collapse"
                            aria-expanded="false" aria-controls="current_medicine" href="!#" style={{ color: '#5C5C5C' }} className="d-block nostyle-link collapsed" onClick={e => this.handleActiveMedsList()}
                        >
                            Current Meds
                        </div>
                        :
                        <button className="btn btn-outline-primary text-right text-uppercase  small  px-2" onClick={e => this.handleActiveMedsList()} > CURRENT MEDS </button>

                }


                <Modal
                    title={false}
                    visible={this.state.activeMediListModal}
                    onCancel={() => this.handleCancel()}
                    destroyOnClose={true}
                    footer={false}
                    width="1380px"
                    className='drug_modal'
                >
                    <Form
                        className='emrfrm'
                    >
                        <div className='row d-flex align-items-center'>
                            <div className='col-10'>
                                <h1 className="page-title mb-4">
                                    Current Medications
                                </h1>
                            </div>
                            <div className='col-2'>
                                <button className="btn btn-outline-primary form-group px-4 py-2 small font-col text-uppercase"
                                    type="button"
                                    // disabled={!this.state.selectDrugValue ? 'disabled' : !this.state.selectDrugValue ? 'disabled' : !this.state.showAddDrugButton ? 'disabled' : null}
                                    onClick={() => this.addMedicine()}
                                >ADD Medicine</button>
                            </div>
                        </div>
                        <div className=' mb-2 px-0 container drug_list_container'>
                            <Table
                                ref={el => (this.componentRef = el)}
                                columns={columns}
                                dataSource={this.state.current_medicine_list}
                                loading={this.state.current_medicine_load}
                                pagination={false}
                                scroll={{ y: 390 }}
                            />
                        </div>
                    </Form>
                </Modal>

                <Modal
                    title={false}
                    visible={this.state.isMedicineShow}
                    onCancel={() => { this.setState({ isMedicineShow: false})}}
                    destroyOnClose={true}
                    footer={false}
                    width="1380px"
                    className='drug_modal'
                >
                    <Form className="emrfrm">
                        <div className="row g-3">

                            {/* Medication Name */}
                            <div className="col-md-4">
                                <div className="form-group add_buttons font-col">
                                    {!this.state.showAddDrugButton && (
                                        <div
                                            className="btn btn-outline-primary mb-2"
                                            onClick={() => this.handleAddDrug()}
                                        >
                                            ADD
                                        </div>
                                    )}
                                    <AutoComplete
                                        ref={this.currentMedicinesListRef}
                                        id="medication_name"
                                        name="medication_name"
                                        style={{ width: '100%' }}
                                        showSearch
                                        showArrow={this.state.showAddDrugButton}
                                        notFoundContent={this.state.formIsFetchingDrug ? LOADER_BLACK : null}
                                        loading={this.state.formIsFetchingDrug}
                                        onSelect={this.onChangeDrugsSelect}
                                        onSearch={this.onDrugssearch}
                                        className="select-drugs"
                                        value={this.state.selectDrugValue}
                                        filterOption={false}
                                        dropdownClassName="custom_drug_select"
                                        autoFocus={!this.state.selectDrugValue}
                                        showAction={!this.state.selectDrugValue ? ['focus', 'click'] : []}
                                    >
                                        {this.optionDrugLoad()}
                                    </AutoComplete>
                                    <label htmlFor="medication_name">
                                        Medicine Name and Strength<span className="text-danger">*</span>
                                    </label>
                                </div>
                            </div>

                            {/* Route */}
                            <div className="col-md-2">
                                <div className="form-group">
                                    <Select
                                        showSearch
                                        onChange={this.onChangeDrugRoute}
                                        id="route"
                                        name="drug_route"
                                        style={{ width: '100%' }}
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {this.optionRouteLoad()}
                                    </Select>
                                    <label htmlFor="route">Route</label>
                                </div>
                            </div>

                            {/* Priority */}
                            <div className="col-md-2">
                                <div className="form-group">
                                    <Select
                                        showSearch
                                        id="urgency"
                                        onChange={this.onChangeDrugUrgency}
                                        value={this.state.drug_urgency}
                                        name="drug_urgency"
                                        style={{ width: '100%' }}
                                        // placeholder="Priority"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {this.optionPriorityLoad()}
                                    </Select>
                                    <label htmlFor="urgency">Priority</label>
                                </div>
                            </div>

                            {/* Frequency */}
                            <div className="col-md-2">
                                <div className="form-group">
                                    <Select
                                        showSearch
                                        id="daily_frequency"
                                        name="daily_frequency"
                                        style={{ width: '100%' }}
                                        // placeholder="Frequency"
                                        onChange={this.onSelectDailyFrequencyChange}
                                        className="drug-input dailyFrequency"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {this.optiondaily_frequencyLoad()}
                                    </Select>
                                    <label htmlFor="daily_frequency">
                                        Frequency
                                    </label>
                                </div>
                            </div>

                            {/* Dosage & Unit */}
                            <div className="col-md-3">
                                <div className="row g-2">
                                    <div className="col-6">
                                        <div className="form-group hasdata">
                                            <input
                                                type="text"
                                                className={`form-control`}
                                                maxLength="10"
                                                name="drug_dosage"
                                                // id="drug_dosage"
                                                // disabled={this.state.dosageDisable}
                                                // onBlur={this.onBlurDrugDosage}
                                                onChange={this.onBlurDrugDosage}
                                                value={this.state.drug_dosage}
                                                // placeholder="Dosage"
                                            />
                                            <label htmlFor="drug_dosage">Dosage</label>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group hasdata">
                                            <Select
                                                showSearch
                                                id="drug_dosage_form_text"
                                                name="drug_dosage_form_text"
                                                style={{ width: '100%' }}
                                                onChange={this.handleSelectOnUomChange}
                                                className="input-group-addons med_addon_height"
                                                value={this.state.drug_dosage_form_text}
                                                // disabled={this.state.dosageDisable}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().includes(input.toLowerCase())
                                                }
                                            >
                                                {this.optionUomDrugLoad()}
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Instructions */}
                            <div className="col-md-3">
                                <div className="form-group mb-0">
                                    <Select
                                        id="drug_instruction"
                                        name="drug_instruction"
                                        style={{ width: '100%' }}
                                        // placeholder="Instructions"
                                        onChange={this.onChangeDrugInstruction}
                                        className={`drug-input drug_Instructions ${(!this.state.drug_instruction && this.state.isBorderColor) ? "custom-pink" : ""}`}
                                        value={this.state.drug_instruction}
                                        showSearch={false}
                                    >
                                        {this.optionInstructionLoad()}
                                    </Select>
                                    <label htmlFor="drug_instruction">Instructions</label>
                                </div>
                            </div>

                            {/* Schedule */}
                            <div className="col-md-3">
                                <div className="form-group">
                                    <Select
                                        showSearch
                                        id="schedules"
                                        name="schedules"
                                        style={{ width: '100%' }}
                                        mode="multiple"
                                        allowClear
                                        value={this.state.drug_schedules}
                                        onChange={this.selectSchedulesChange}
                                        // onSelect={this.schedulesSelected}
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {this.optionschedulesLoad()}
                                    </Select>
                                    <label htmlFor="schedules">Schedule</label>
                                </div>
                            </div>

                            {/* Duration */}
                                <div className="col-md-3">
                                    <div className="form-group hasdata input-group frequency-field-row">
                                        {/* <input
                                            type="text"
                                            className={`form-control onlynumbers custom_border-med ${(!this.state.drug_number_of_days && this.state.isBorderColor) ? "custom-pink" : ""}`}
                                            maxLength="3"
                                            name="drug_number_of_days"
                                            id="number_of_days"
                                            // disabled={this.state.disableNumberOfDays || this.state.addContinueTillReview === 'Y'}
                                            onChange={this.onChangeNumberOfDays}
                                            value={this.state.drug_number_of_days}
                                            // placeholder="Duration"
                                        /> */}
                                          <input
                                                type="text"
                                                className={`form-control`}
                                                maxLength="10"
                                                name="drug_number_of_days"
                                                // id="drug_dosage"
                                                // disabled={this.state.dosageDisable}
                                                // onBlur={this.onBlurDrugDosage}
                                                onChange={this.onChangeNumberOfDays}
                                                value={this.state.drug_number_of_days}
                                                // placeholder="Dosage"
                                            />
                                        <Select
                                            id="drug_duration_time"
                                            name="drug_duration_time"
                                            // placeholder="Duration"
                                            onChange={this.onChangeDurationType}
                                            className="input-group-addons med_addon_height"
                                            value={this.state.drug_duration_time}
                                            // disabled={this.props.formType !== 'template' && !this.state.durationChange}
                                        >
                                            {this.optionDurationTypeLoad()}
                                        </Select>
                                        <label htmlFor="drug_duration_time">Duration</label>
                                    </div>
                                </div>

                            {/* Start Date */}
                            <div className="col-md-3">
                                <div className="form-group hasdata">
                                    <DatePicker
                                        value={this.state.drug_start_date ? moment(this.state.drug_start_date) : null}
                                        onChange={this.updateStartDate}
                                        format="DD/MM/YYYY"
                                        className="form-control"
                                        // disabledDate={(current) => current && current < moment().startOf('day')}
                                    />
                                    <label htmlFor="start_date">Start Date</label>
                                </div>
                            </div>

                            {/* End Date */}
                            <div className="col-md-3">
                                <div className={`form-group hasdata ${this.state.drug_end_date ? "hasdata" : ""}`}>
                                    <DatePicker
                                        value={this.state.drug_end_date ? moment(this.state.drug_end_date) : null}
                                        onChange={this.updateEndDate}
                                        format="DD/MM/YYYY"
                                        className="form-control"
                                        disabledDate={(current) => current && current < moment().startOf('day')}
                                    />
                                    <label htmlFor="end_date">End Date</label>
                                </div>
                            </div>
                        </div>

                        {/* Add Button */}
                        <div className='row'>
                            <div className="col-12">
                                <button
                                    className="btn btn-outline-primary px-4 py-2 small font-col text-uppercase"
                                    type="button"
                                    disabled={!this.state.selectDrugValue || !this.state.showAddDrugButton}
                                    onClick={() => this.saveMedicineData()}
                                >
                                    ADD
                                </button>
                            </div>
                        </div>
                    </Form>
                </Modal>
            </Fragment>
        )
    }
}

export default CurrentMedsPopup;
